import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {PermissionService} from "projects/store/src/app/services/permission.service";

interface MultiplePermission {
  permission: string,
  externalPermission: boolean
}

@Directive({
  selector: '[permission]'
})
export class PermissionDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService,
    /*private permissionManagerS: PermissionManagerService*/
  ) { }
  @Input() set permission(permission: string | MultiplePermission) {
    this.isEnabled(permission);
  }
  private isEnabled(permission: string | MultiplePermission) {
    if(typeof permission == 'object') {
      if (permission.externalPermission == false) {
        this.viewContainer.clear();
      }else{
        this.checkPermission(permission.permission);
      }
    }else{
      this.checkPermission(permission);
    }
  }

  private checkPermission(permission: string) {
    if(this.permissionService.checkPermission(permission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }else{
      this.viewContainer.clear();
    }
  }
}
